<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="card card-container create-user">
                        <div class="col-md-12 text-center user-card-header">
                            <h4>Benutzer erstellen</h4>
                        </div>
                        <div id="profile-img" class="profile-img-card" aria-hidden="true"></div>
                        <form name="form" @submit.prevent="createNewUser">
                            <div v-if="!successful">
                                <div class="form-group">
                                    <label for="username">Benutzername</label>
                                    <input v-model="user.username" type="text" class="form-control" name="username"
                                        @blur="checkUsername" />
                                    <p v-if="usernameAvailableWarning" style="color: red">
                                        Benutzername existiert bereits!
                                    </p>
                                    <p v-if="usernameLengthWarning" style="color:red">
                                        Benutzernamen ist zu lang!
                                    </p>
                                    <p v-if="usernameEmptyWarning" style="color:red">
                                        Benutzername kann nicht leer sein
                                    </p>
                                </div>
                                <div class="form-group">
                                    <label for="password">Passwort</label>
                                    <input v-model="user.password" :type="passwordVisible ? 'text' : 'password'"
                                        autocomplete="new-password" class="form-control" name="password"
                                        @blur="checkPasswordLength" />
                                    <div class="password-actions">
                                        <button type="button" class="btn btn-outline-secondary btn-sm"
                                            @click="generateUserPassword">
                                            Generieren
                                        </button>
                                        <button type="button" class="btn btn-outline-secondary btn-sm"
                                            @click="copyUserPassword" :disabled="!user.password">
                                            Kopieren
                                        </button>
                                    </div>
                                    <p v-if="passwordLength" style="color: red">
                                        Passwort muss mehr als 8 Zeichen haben!
                                    </p>
                                </div>
                                <div class="form-group">
                                    <label for="confirm-password">Passwort bestätigen</label>
                                    <input v-model="user.confirmPassword" :type="passwordVisible ? 'text' : 'password'"
                                        autocomplete="new-password" class="form-control" name="confirm-password"
                                        @blur="checkPasswordMatch" />
                                    <p v-if="confirmedPasswordWrong" style="color: red">
                                        Passwörter sind nicht gleich
                                    </p>
                                </div>
                                <div class="form-group">
                                    <label for="role">Benutzerrolle auswählen</label>
                                    <select name="role" class="form-control" v-model="user.role" @blur="checkAssignedRole">
                                        <option value="">Auswählen</option>
                                        <option value="user">Benutzer</option>
                                        <option value="administrator">
                                            Administrator
                                        </option>
                                        
                                    </select>
                                    <p v-if="checkUserRole" style="color: red">
                                        Bitte Benutzerrolle auswählen!
                                    </p>
                                </div>
                                <div class="form-group">
                                    <button class="btn btn-primary btn-block">
                                        Bestätigen
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card card-container">
                        <div class="col-md-12 text-center user-card-header">
                            <h4>Benutzer verwalten</h4>
                        </div>

                        <div class="row col-md-12 user-card row"
                            v-for="(record, index) in users" :key="record._id"
                            :class="{ 'user-card-inactive': !isUserActive(record) }">
                            <div class="col-12 col-sm-6 user-card-name">
                                <p>
                                    <font-awesome-icon v-if="record.role !== 'administrator'" icon="fa-user"
                                        class="user-icon" />
                                    <font-awesome-icon v-else style="color: orange" icon="fa-user" class="user-icon" />
                                    {{ record.login }}
                                    <span v-if="!isUserActive(record)" class="user-status-badge">deaktiviert</span>
                                </p>
                            </div>
                            <div class="col-12 col-sm-6 text-center user-card-buttons">
                                <button class="btn btn-primary" @click="
                                    editUser(
                                        record._id,
                                        record.login,
                                        record.role,
                                        index,
                                    )
                                ">
                                    Ändern
                                </button>
                                <button class="btn"
                                    :class="isUserActive(record) ? 'btn-warning' : 'btn-success'"
                                    v-if="!isCurrentUser(record)"
                                    @click="toggleUserActive(record)">
                                    {{ isUserActive(record) ? 'Deaktivieren' : 'Aktivieren' }}
                                </button>
                                <button class="btn btn-danger" @click="
                                    ($event) =>
                                        deleteUser(record._id, index)
                                " v-if="!isCurrentUser(record)">
                                    Löschen
                                </button>
                            </div>
                        </div>
                        <p></p>
                        <p>
                            <font-awesome-icon style="color: orange" icon="fa-user" class="user-icon" />
                            - Administrator
                        </p>
                        <p>
                            <font-awesome-icon icon="fa-user" class="user-icon" />
                            - Benutzer
                        </p>
                        <p class="user-legend-inactive">
                            <span class="user-status-badge">deaktiviert</span>
                            — kein Login, Sitzung endet
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        <edit-user-window ref="modalEditUser" :edit-password="newPasswordConfirmed"
            @confirm="onEditUserConfirm"></edit-user-window>
    </section>
</template>

<script>
import User from '../../models/user';
import axios from 'axios';
import { useToast } from 'vue-toastification';
import ConfirmDialogue from './static_elements/ConfirmDialogue.vue';
import EditUserWindow from './static_elements/ModalEditUser.vue';
import API_BACKEND_URL from '@/API_URL/api_back_end.js';
import { getToken } from '@/services/tokenStore';
import { copyTextToClipboard, generatePassword } from '@/utils/generatePassword';

export default {
    name: 'userRegister',
    components: { ConfirmDialogue, EditUserWindow },
    data() {
        return {
            user: new User('', '', ''),
            submitted: false,
            successful: false,
            message: '',
            usernameAvailableWarning: false,
            usernameLengthWarning: false,
            usernameEmptyWarning: false,
            confirmedPasswordWrong: false,
            passwordLength: false,
            checkUserRole: false,
            passwordVisible: false,
            // Toast
            toast: useToast(),
            // UserList
            users: [],
            // Display Edit area
            selectedIndex: '',
            // Update edit pass:
            newPasswordConfirmed: '',
            userName: '',
        };
    },
    methods: {
        authHeaders() {
            const token = getToken();
            return token ? { token } : {};
        },
        isUserActive(record) {
            return Boolean(record) && record.active !== false;
        },
        isCurrentUser(record) {
            return this.$store.state.auth.user.login === record.login;
        },
        handleAuthError(err) {
            const status = err.response?.status;
            if (status === 401 || status === 403) {
                this.toast.warning('Keine Berechtigung für diesen Bereich.', { timeout: 3000 });
                this.$router.push('/home');
                return true;
            }
            return false;
        },
        async checkUsername() {
            this.user.username = this.user.username.trim()
            if (this.user.username != '') {
                const response = await axios.post(
                    `${API_BACKEND_URL}check-username`,
                    {
                        login: this.user.username,
                    },
                );
                this.usernameAvailableWarning = !response.data.unique;
                if (this.user.username.length > 20) {
                    this.usernameLengthWarning = true;
                } else {
                    this.usernameLengthWarning = false;
                }
                this.usernameEmptyWarning = false;
            }else{
                this.usernameEmptyWarning = true;
            }
        },
        checkPasswordLength() {
            if (this.user.password.length < 8) {
                this.passwordLength = true;
            } else {
                this.passwordLength = false;
            }
        },
        checkPasswordMatch() {
            if (this.user.password !== this.user.confirmPassword) {
                console.log(this.user.password, this.user.confirmPassword);
                this.confirmedPasswordWrong = true;
            } else {
                this.confirmedPasswordWrong = false;
            }
        },
        checkAssignedRole() {
            if (this.user.role === '') {
                this.checkUserRole = true;
            } else {
                this.checkUserRole = false;
            }
        },
        async generateUserPassword() {
            const password = generatePassword(10);
            this.user.password = password;
            this.user.confirmPassword = password;
            this.passwordVisible = true;
            this.passwordLength = false;
            this.confirmedPasswordWrong = false;
            try {
                const ok = await copyTextToClipboard(password);
                this.toast.success(
                    ok
                        ? 'Passwort generiert und kopiert.'
                        : 'Passwort generiert — bitte mit „Kopieren“ übernehmen.',
                    { timeout: 2500 },
                );
            } catch (err) {
                this.toast.success('Passwort generiert — bitte mit „Kopieren“ übernehmen.', {
                    timeout: 2500,
                });
                console.log(err);
            }
        },
        async copyUserPassword() {
            try {
                const ok = await copyTextToClipboard(this.user.password);
                if (ok) {
                    this.toast.success('Passwort kopiert.', { timeout: 1500 });
                } else {
                    this.toast.warning('Kopieren nicht möglich — bitte manuell markieren.', {
                        timeout: 3000,
                    });
                }
            } catch (err) {
                this.toast.warning('Kopieren nicht möglich — bitte manuell markieren.', {
                    timeout: 3000,
                });
                console.log(err);
            }
        },
        clearInput() {
            this.user.username = '';
            this.user.password = '';
            this.user.confirmPassword = '';
            this.user.role = '';
            this.usernameAvailableWarning = false;
            this.usernameEmptyWarning = false;
            this.passwordLength = false;
            this.confirmedPasswordWrong = false;
            this.checkUserRole = false;
            this.usernameLengthWarning = false;
            this.passwordVisible = false;
        },
        createNewUser() {
            if (
                !this.usernameAvailableWarning &&
                !this.usernameEmptyWarning &&
                !this.passwordLength &&
                !this.confirmedPasswordWrong &&
                !this.checkUserRole &&
                !this.usernameLengthWarning && 
                this.user.username.length > 2
            ) {
                // console.log(this.user);
                axios
                    .post(API_BACKEND_URL + 'create_user', this.user, {
                        headers: this.authHeaders(),
                    })
                    .then((res) => {
                        if (res.status === 200) {
                            this.toast.success(
                                'Benutzer wurde erstellt!',
                                {
                                    timeout: 2000,
                                },
                            );
                            this.getUserList();
                            this.clearInput()
                        } else {
                            this.toast.warning(res.data, { timeout: 4000 });
                        }
                    }).catch((err) => {
                        if (!this.handleAuthError(err)) {
                            this.toast.warning('Unbekannter Fehler!', { timeout: 4000 });
                            console.log(err);
                        }
                    })
            } else {
                this.completeMessage = false;
                this.toast.warning('Bitte überprüfe deine eingabe!', { timeout: 4000 });
                this.completeMessageText = 'Bitte überprüfe deine eingabe!';
            }
        },
        editUser(id, login, role, index) {
            this.selectedIndex = index;
            this.userName = login;
            this.$refs.modalEditUser.show({
                userName: login,
                userRole: role,
                userRecordId: id,
            });
        },
        onEditUserConfirm(newPassword, userRole) {
            let update = {
                login: this.userName,
                password: newPassword,
                role: userRole,
            };
            axios
                .post(API_BACKEND_URL + 'update_user_record', update, {
                    headers: this.authHeaders(),
                })
                .then((res) => {
                    if (res.status === 200) {
                        this.toast.success('Fertig!', {
                            timeout: 2000,
                        });
                        this.clearInput()
                    }
                }).catch((err) => {
                    if (!this.handleAuthError(err)) {
                        this.toast.warning('Unbekannter Fehler!', {
                            timeout: 2000,
                        });
                        console.log(err);
                    }
                });
        },
        async toggleUserActive(record) {
            const nextActive = !this.isUserActive(record);
            const ok = await this.$refs.confirmDialogue.show({
                title: nextActive ? 'Benutzer aktivieren' : 'Benutzer deaktivieren',
                message: nextActive
                    ? 'Der Benutzer kann sich danach wieder anmelden.'
                    : 'Der Benutzer kann sich danach nicht mehr anmelden. Eine offene Sitzung endet beim nächsten Aufruf.',
                okButton: nextActive ? 'Aktivieren' : 'Deaktivieren',
            });
            if (!ok) {
                return;
            }
            try {
                const res = await axios.post(
                    `${API_BACKEND_URL}update_user_record`,
                    { login: record.login, active: nextActive },
                    { headers: this.authHeaders() },
                );
                if (res.status === 200) {
                    this.toast.success(
                        nextActive ? 'Benutzer wurde aktiviert.' : 'Benutzer wurde deaktiviert.',
                        { timeout: 2000 },
                    );
                    this.getUserList();
                }
            } catch (err) {
                if (this.handleAuthError(err)) {
                    return;
                }
                const code = err.response?.data?.error;
                if (code === 'cannot deactivate own account') {
                    this.toast.warning('Eigenes Konto kann nicht deaktiviert werden.', {
                        timeout: 3000,
                    });
                } else if (code === 'cannot deactivate last administrator') {
                    this.toast.warning('Der letzte Administrator kann nicht deaktiviert werden.', {
                        timeout: 3000,
                    });
                } else {
                    this.toast.warning('Unbekannter Fehler!', { timeout: 2000 });
                    console.log(err);
                }
            }
        },
        async deleteUser(id, index) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Benutzer löschen',
                message:
                    'Bist du sicher?',
                okButton: 'Löschen',
            });
            if (ok) {
                console.log(id, index);
                try {
                    await axios
                        .delete(`${API_BACKEND_URL}delete_user/${id}`, {
                            headers: this.authHeaders(),
                        })
                        .then((res) => {
                            if (res.status === 200) {
                                this.users.splice(index, 1);
                                this.toast.success(
                                    'Fertig!',
                                    {
                                        timeout: 2000,
                                    },
                                );
                            }
                        })
                        .catch((error) => {
                            if (!this.handleAuthError(error)) {
                                this.toast.warning('Unbekannter Fehler!', {
                                    timeout: 2000,
                                });
                                console.log(error);
                            }
                        });
                } catch (err) {
                    this.toast.success(err, { timeout: 4000 });
                }
            }
        },
        getUserList() {
            try {
                axios
                    .get(API_BACKEND_URL + 'get_user_list', {
                        headers: this.authHeaders(),
                    })
                    .then((res) => {
                        if (res.status === 500) {
                            this.toast.warning(res.data, { timeout: 4000 });
                        } else if (res.status === 200) {
                            this.users = res.data;
                        }
                    })
                    .catch((err) => {
                        if (!this.handleAuthError(err)) {
                            console.log(err);
                            this.toast.warning('Unbekannter Fehler!', {
                                timeout: 2000,
                            });
                        }
                    });
            } catch (err) {
                this.toast.warning('Unbekannter Fehler!', {
                    timeout: 2000,
                });
                console.log(err);
            }
        },
    },
    created() {
        this.getUserList();
    },
};
</script>

<style scoped>
section {
    margin-top: var(--app-header-height);
    padding: 0.85rem 1rem calc(var(--app-footer-height) + 0.5rem);
}

label {
    display: block;
    margin-top: 10px;
}

.card-container.card {
    max-width: 450px !important;
    padding: 40px 40px;
}

.card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 1.25rem;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.profile-img-card {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    border-radius: 50%;
    background-color: #c5c5c5;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3E%3Ccircle cx='64' cy='48' r='24' fill='%23888888'/%3E%3Cellipse cx='64' cy='104' rx='40' ry='28' fill='%23888888'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 70%;
}

.form-group:nth-child(5) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2rem;
}

.user-card {
    background-color: #fff;
    min-height: 2rem;
    border-radius: 15px;
    border: 2px solid #c1c1c1;
    margin: 0.5rem auto;
    align-items: center;
    overflow: hidden;
}

.user-card-header {
    margin-bottom: 1rem;
}

.user-card-name {
    display: flex;
    align-items: center;
    padding-left: 1rem;
    font-size: 1.3rem;
}

.user-icon {
    font-size: 1.2rem;
}

.user-card-name p {
    margin: 0px !important;
}

.user-card-inactive {
    background-color: #f0f0f0;
    border-color: #d0d0d0;
}

.user-card-inactive .user-card-name {
    color: #6c6c6c;
}

.user-status-badge {
    display: inline-block;
    margin-left: 0.4rem;
    padding: 0.1rem 0.45rem;
    border-radius: 999px;
    background-color: #e9ecef;
    color: #5c5c5c;
    font-size: 0.75rem;
    font-weight: 600;
    vertical-align: middle;
}

.user-legend-inactive {
    color: #5c5c5c;
}

.user-card-buttons {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.password-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
}


@media (max-width: 768px) {
    section {
        padding-top: 0.85rem;
    }

    .card-container.card {
        padding: 0px;
    }

    .card-container.card.create-user {
        padding: 25px;
    }

    .card-container.card p {
        margin-left: 2rem;
    }

    .card-container:nth-child(1) {
        margin-bottom: 4rem;
    }

    .user-card-header {
        margin: 1rem;
    }

    .user-card-header h4 {
        font-size: 2.4rem;
    }

    .user-card {
        margin: 0.5rem 1rem;
        padding: 0.65rem 0.75rem;
    }

    .user-card-name {
        padding-left: 0.25rem;
        padding-bottom: 0.35rem;
        font-size: 1.15rem;
    }

    .user-card-buttons {
        justify-content: flex-start;
        padding: 0.25rem 0 0;
        gap: 0.5rem;
    }

    .user-card-buttons .btn {
        font-size: 0.9rem;
        padding: 0.35rem 0.75rem;
    }
}</style>
